"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiProfileMin } from "@/generated/models/ApiProfileMin";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { Dialog, DialogPanel, Transition, TransitionChild } from "@headlessui/react";
import { Fragment, useEffect } from "react";
import { createPortal } from "react-dom";
import ArtistPreviewAppWrapper from "./ArtistPreviewAppWrapper";
import { WaveCreatorPreviewModalContent } from "./WaveCreatorPreviewModalContent";
interface WaveCreatorPreviewModalProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly user: ApiProfileMin;
}
export const WaveCreatorPreviewModal = t0 => {
  const $ = _c(29);
  const {
    isOpen,
    onClose,
    user
  } = t0;
  const {
    isApp
  } = useDeviceInfo();
  let t1;
  let t2;
  if ($[0] !== isApp || $[1] !== isOpen) {
    t1 = () => {
      if (!isOpen || isApp) {
        return;
      }
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = originalOverflow;
      };
    };
    t2 = [isOpen, isApp];
    $[0] = isApp;
    $[1] = isOpen;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (!isOpen) {
    return null;
  }
  if (isApp) {
    let t3;
    if ($[4] !== isOpen || $[5] !== onClose || $[6] !== user) {
      t3 = <WaveCreatorPreviewModalContent user={user} isOpen={isOpen} onClose={onClose} isApp={true} />;
      $[4] = isOpen;
      $[5] = onClose;
      $[6] = user;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    let t4;
    if ($[8] !== isOpen || $[9] !== onClose || $[10] !== t3) {
      t4 = <ArtistPreviewAppWrapper isOpen={isOpen} onClose={onClose}>{t3}</ArtistPreviewAppWrapper>;
      $[8] = isOpen;
      $[9] = onClose;
      $[10] = t3;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    return t4;
  }
  let t3;
  if ($[12] !== onClose) {
    t3 = <TransitionChild as={Fragment} enter="tw-duration-200 tw-ease-out" enterFrom="tw-opacity-0" enterTo="tw-opacity-100" leave="tw-duration-200 tw-ease-in" leaveFrom="tw-opacity-100" leaveTo="tw-opacity-0"><div className="tw-fixed tw-inset-0 tw-bg-iron-600/60" onClick={e => {
        e.stopPropagation();
        onClose();
      }} /></TransitionChild>;
    $[12] = onClose;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== isOpen || $[15] !== onClose || $[16] !== user) {
    t4 = <div className="tw-fixed tw-inset-0 tw-z-[100] tw-hidden tw-overflow-y-auto tw-scrollbar-thin tw-scrollbar-track-iron-800 tw-scrollbar-thumb-iron-500 hover:tw-scrollbar-thumb-iron-300 sm:tw-block"><div className="tw-flex tw-min-h-full tw-items-center tw-justify-center tw-p-4"><TransitionChild as={Fragment} enter="tw-duration-0" enterFrom="tw-opacity-100" enterTo="tw-opacity-100" leave="tw-duration-0" leaveFrom="tw-opacity-100" leaveTo="tw-opacity-100"><DialogPanel className="tw-relative tw-m-0 tw-max-h-[90vh] tw-w-full tw-max-w-3xl tw-overflow-hidden tw-rounded-xl tw-border tw-border-iron-800 tw-bg-iron-950 tw-p-0 tw-shadow-2xl tw-shadow-black/25" onClick={_temp2}><WaveCreatorPreviewModalContent user={user} isOpen={isOpen} onClose={onClose} isApp={false} /></DialogPanel></TransitionChild></div></div>;
    $[14] = isOpen;
    $[15] = onClose;
    $[16] = user;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== isOpen || $[19] !== onClose || $[20] !== user) {
    t5 = <div className="tw-fixed tw-inset-0 tw-block tw-overflow-hidden sm:tw-hidden"><div className="tw-absolute tw-inset-0 tw-overflow-hidden"><div className="tw-pointer-events-none tw-fixed tw-inset-x-0 tw-bottom-0 tw-flex tw-max-w-full tw-pt-10"><TransitionChild as={Fragment} enter="tw-transform tw-transition tw-duration-300 tw-ease-out" enterFrom="tw-translate-y-full" enterTo="tw-translate-y-0" leave="tw-transform tw-transition tw-duration-300 tw-ease-in" leaveFrom="tw-translate-y-0" leaveTo="tw-translate-y-full"><DialogPanel className="tw-pointer-events-auto tw-relative tw-max-h-[90vh] tw-w-screen tw-transform-gpu tw-overflow-hidden tw-rounded-t-xl tw-border-t tw-border-iron-800 tw-bg-iron-950 tw-shadow-2xl tw-shadow-black/25 tw-will-change-transform" onClick={_temp3}><WaveCreatorPreviewModalContent user={user} isOpen={isOpen} onClose={onClose} isApp={false} /></DialogPanel></TransitionChild></div></div></div>;
    $[18] = isOpen;
    $[19] = onClose;
    $[20] = user;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== t3 || $[23] !== t4 || $[24] !== t5) {
    t6 = <Dialog as="div" className="tw-relative tw-z-[9999] tw-cursor-default" onClose={_temp}>{t3}{t4}{t5}</Dialog>;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] !== isOpen || $[27] !== t6) {
    t7 = createPortal(<Transition show={isOpen} as={Fragment}>{t6}</Transition>, document.body);
    $[26] = isOpen;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  return t7;
};
function _temp() {}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp3(e_1) {
  return e_1.stopPropagation();
}